<template>
    <div id="index">
        <h3>
            Admin
        </h3>

    </div>
</template>

<script>
export default {
    props: {
    },
    data() {
        return {
            is_loading: false
        }
    },
    mounted() {
        this.set_breadcrumbs()
    },
    watch: {
        '$route'(to, from) {
            this.set_breadcrumbs()
        }
    },
    methods: {
        set_breadcrumbs() {
            this.$store.state.breadcrumbs = []
        }
    },
    components: {
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
</style>
